var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"guest-background"}),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('span',{staticClass:"app-version"},[_vm._v(_vm._s(_vm.$t('ceremony.version', { version: _setup.appVersion })))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }